(function() {

	/**
	 * Behavior for a single accordion item.
	 * Enables 
	 */
	class AccordionItem {
		constructor(target, callback) {
			/**
			 * CSS classes to indicate opened states. 
			 */
			this.cssClasses = {
				item: 'accordion__item--expanded',
				collapse: 'accordion__collapse--expanded',
			};

			/**
			 * ARIA states for indicated open and closed states to screen readers.
			 */
			this.ariaStates = {
				expanded: {
					OPEN: 'true',
					CLOSED: 'false',
				},
			};

			/**
			 * Flag for keeping the opened or closed state of this accordion.
			 */
			this.isOpened = false;

			/**
			 * Elements of this accordion.
			 */
			this.item = target;
			this.button = target.querySelector('.accordion__button');
			this.collapse = target.querySelector('.accordion__collapse');
			this.body = target.querySelector('.accordion__body');

			/**
			 * Handle the passed callback on a button click.
			 */
			const onButtonClick = () => {
				callback(this);
			};

			this.button.addEventListener('click', onButtonClick);

			/**
			 * Remove the inline style and toggle opened classes after the accordion
			 * finished its transition.
			 * @returns {void}
			 */
			const onCollapseTransitionEnd = () => {
				this.collapse.style.maxHeight = '';

				// Remove the entire attribute if it is empty.
				if (this.collapse.style.length === 0) {
					this.collapse.removeAttribute('style');
				}

				if (this.isOpened === true) {
					this.collapse.classList.add(this.cssClasses.collapse);
				} else {
					this.collapse.classList.remove(this.cssClasses.collapse);
				}
			};

			this.collapse.addEventListener('transitionend', onCollapseTransitionEnd);
		}

		/**
		 * Opens the collapse section.
		 * @returns {void}
		 */
		open() {
			this.isOpened = true;
			
			requestAnimationFrame(() => {
				this.item.classList.add(this.cssClasses.item);
				this.button.setAttribute('aria-expanded', this.ariaStates.expanded.OPEN);
				this.collapse.style.maxHeight = '0px';
				requestAnimationFrame(() => {
					this.collapse.style.maxHeight = `${this.body.offsetHeight}px`;
				});
			});
		}

		/**
		 * Closes the collapse section.
		 * @returns {void}
		 */
		close() {
			this.isOpened = false;
			
			requestAnimationFrame(() => {
				this.item.classList.remove(this.cssClasses.item);
				this.button.setAttribute('aria-expanded', this.ariaStates.expanded.CLOSED);
				this.collapse.style.maxHeight = `${this.body.offsetHeight}px`;
				requestAnimationFrame(() => {
					this.collapse.style.maxHeight = '0px';
				});
			});
		}

		/**
		 * Either open or collapse the content.
		 * @returns {void} 
		 */
		toggle() {
			this.isOpened 
				? this.close() 
				: this.open();
		}
	}

	/**
	 * A collection of accordion groups.
	 */
	const accordionsGroups = document.querySelectorAll('.js-accordion');

	/**
	 * Initialize Accordion behavior for this accordion group.
	 * @param {HTMLElement} accordion 
	 */
	const initAccordionGroup = accordion => {
		const accordionItemElements = accordion.querySelectorAll('.accordion__item');

		/**
		 * Store all AccordionItem instances.
		 */
		const accordionItems = [];

		/**
		 * Manages the open and close states for each accordion item.
		 * When an accordion is closed it will open.
		 * When one is opened and another is clicked, it will first close the opened one and the open the clicked accordion.
		 * @param {AccordionItem} accordionItem 
		 * @returns {void}
		 */
		const onAccordionClick = accordionItem => {
			if (accordionItem.isOpened === false) {
				accordionItems.forEach(item => {
					if (item.isOpened === true) {
						item.close();
					}
				});
				
				accordionItem.open();
			} else {
				accordionItem.close();
			}
		}
		
		/**
		 * Initialize the behavior for each single accordion item.
		 * @param {HTMLElement} element 
		 */
		const initAccordionItem = element => {
			const accordionItem = new AccordionItem(element, onAccordionClick);
			accordionItems.push(accordionItem);
		};

		accordionItemElements.forEach(initAccordionItem);
	}

	accordionsGroups.forEach(initAccordionGroup);
}());



// WEBPACK FOOTER //
// ./scripts/custom/accordion.js